import React from "react";
import { useQuery } from "react-query";

import {
  // Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  Typography,
} from "@material-ui/core";

import styled from "styled-components/macro";

import Table from "../../../components/Table";
import { spacing } from "@material-ui/system";
import Panel from "../../../components/panels/Panel";

import { Helmet } from "react-helmet-async";
import Loader from "../../../components/Loader";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

const TableWrapper = styled.div`
  overflow-y: auto;
  max-width: calc(100vw - ${(props) => props.theme.spacing(12)}px);
  max-height: calc(100% - 48px);
`;

const Divider = styled(MuiDivider)(spacing);

//388px
const SiteSummaryTable = () => {
  const { getAccessTokenSilently } = useAuth0();

  const { data, isFetching, error } = useQuery(
    ["ui-site-summary"],
    async () => {
      try {
        const token = await getAccessTokenSilently();
        const headers = { Authorization: `Bearer ${token}` };

        const { data } = await axios.get(
          `${process.env.REACT_APP_ENDPOINT}/api/ui-site-summary/`,
          { headers }
        );

        return data;
      } catch (err) {
        console.error(err);
      }
    },
    { keepPreviousData: true, refetchOnWindowFocus: false }
  );

  if (error) return "An error has occurred: " + error.message;

  const tabColumns = [
    {
      title: "Well ID",
      field: "well_id",
    },
    {
      title: "Parameter",
      field: "parameter",
    },
    {
      title: "Data Provider",
      field: "data_provider",
    },
    {
      title: "Last Reported Value",
      field: "last_reported_value",
    },
    {
      title: "Unit Description",
      field: "unit_desc",
    },
    {
      title: "Starting Period of Record",
      field: "start_period_of_record",
      type: "date",
    },
    {
      title: "Ending Period of Record",
      field: "end_period_of_record",
      type: "date",
    },
    {
      title: "Record Count",
      field: "recordcount",
    },
    {
      title: "Latitude",
      field: "lat",
    },
    {
      title: "Longitude",
      field: "lon",
    },
  ];

  return (
    <>
      <Helmet title="Site Summary Table" />
      <Typography variant="h3" gutterBottom display="inline">
        Site Summary Table
      </Typography>

      <Divider my={6} />
      <Panel>
        <TableWrapper>
          {data ? (
            <Table
              label="Site Summary Table"
              isLoading={isFetching}
              columns={tabColumns}
              data={data}
              height="calc(100vh - 64px - 48px - 106px - 48px - 64px - 156px)"
              pageSize={30}
            />
          ) : (
            <Loader />
          )}
        </TableWrapper>
      </Panel>
    </>
  );
};

export default SiteSummaryTable;
